import React, { useContext } from 'react';
import { DeleteStorageDataContext } from 'context/DeleteStorageContext';
import InputField from 'sub_components/Common/BloxTextInput';
import styled from 'styled-components';

const ConfirmScreenTwoStyle = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.blox-text-input {
		width: 100%;
		margin-bottom: 8px;
	}
	.start {
		text-align: center;
		margin-bottom: 10px;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const ConfirmScreenTwo = ({ share }) => {
	const { inputs, change } = useContext(DeleteStorageDataContext);

	return (
		<ConfirmScreenTwoStyle>
			<div className='start body10'>
				{`Do you still want to delete ${share?.common_name} ?
				If you are absolutely sure and understand this cannot be undone, then enter the name of the
				storage we're deleting and select "Make it so!".`}
			</div>
			<InputField
				type={'INPUT'}
				label='Storage Name'
				name={'name'}
				value={inputs?.name}
				validations={[]}
				onChange={change}
				active={true}
				hideCheckmark
				cypressId='delete-storage-input'
			/>
		</ConfirmScreenTwoStyle>
	);
};
